import classNames from 'classnames';
import * as React from 'react';
import { Link } from '~/Partials/Link/Link';
import { LinkType } from '~/Partials/Link/LinkType.csharp';
import styles from './PillTag.module.css';
import type { PillTagFontColor } from './PillTagFontColor';
import type { PillTagSize } from './PillTagSize';
import type { PillTagType } from './PillTagType';
import type { PillTagVariant } from './PillTagVariant';

export interface PillTagProps {
    title?: string;
    variant?: PillTagVariant;
    type?: PillTagType;
    size?: PillTagSize;
    href?: string;
    fontColor?: PillTagFontColor;
    className?: string;
}

export const PillTag: React.FC<React.PropsWithChildren<PillTagProps>> = props => {
    const {
        title,
        href,
        children,
        className,
        variant = 'default',
        size = 'normal',
        type = 'solid',
        fontColor = 'default',
    } = props;

    const baseProps = {
        className: classNames(
            styles.PillTag,
            styles[`Variant--${variant}`],
            styles[`Variant--${size}`],
            styles[`Variant--${type}`],
            styles[`Variant--${fontColor}Font`],
            href ? styles['Variant--link'] : styles['Variant--basic'],
            className
        ),
        title,
    };

    if (href) {
        return (
            <Link href={href} {...baseProps} type={LinkType.Clear} labelClassName={styles.LinkLabel}>
                {children}
            </Link>
        );
    }

    return <div {...baseProps}>{children}</div>;
};
